import { BaseCommand } from './BaseCommand';
import { goto } from '$app/navigation';
import { queryCollection } from '$lib/firebase/firestore';

export class OrganizationCommand extends BaseCommand {
  getKeywords() {
    return ['org', 'organization'];
  }

  parameterDescriptions = [{ key: 'query', description: 'The organization name or admin email to search' }];

  async action() {
    const query = this.parameters[0]?.toLowerCase();
    if (!query) {
      goto('/admin/organizations');
      return;
    }

    try {
      const snap = await queryCollection<any>('organizations', []);
      const matches = snap.docs.filter((doc) => {
        const data = doc.data();
        return (
          data.name?.toLowerCase().includes(query) ||
          data.adminEmails?.some((e: string) => e.toLowerCase().includes(query))
        );
      });

      if (matches.length === 0) {
        goto('/admin/organizations');
        return;
      }

      return matches.map((doc) => ({
        message: `🏢 Organization: ${doc.data().name || 'Unnamed'} (${doc.data().seats || 0} seats)`,
        action: (event: Event, onAction?: () => void) => {
          const url = `/admin/organizations`;
          if ((event as MouseEvent).metaKey) {
            window.open(url, '_blank');
          } else {
            goto(url);
          }
          onAction?.();
        },
      }));
    } catch (e) {
      goto('/admin/organizations');
    }
  }
}
